import { connect } from 'react-redux';
import React, { Component } from 'react';

import { Link } from 'libs/router';

import Form from 'components/form/Form';
import FormField from 'components/form/form-field/FormField';
import Input from 'components/inputs/input/Input';

import { login } from '../reducers/session';
import { notification } from 'redux-store/reducers/common-reducer';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { isEmail, isRequired } from 'utils/validators';
import { t } from 'utils/language';

import '../common/access-form.scss';
import '../common/access-actions.scss';

import type { LocationWindow } from 'types';

type Props = {
  dispatch: any,
  location: LocationWindow
};

type State = {
  email: string,
  password: string
};

class LoginForm extends Component<Props, State> {
  state = {
    email: '',
    password: ''
  };

  componentDidMount() {
    this.dispatchSuccessNotification();
  }

  dispatchSuccessNotification() {
    const { dispatch, location } = this.props;
    const { query } = location;

    let message: string | null = null;

    if (query.signup) {
      message = t('signup_successful');
    }

    if (query.activation) {
      message = t('activation_successful');
    }

    if (message) {
      dispatch(notification({
        type: 'success',
        keepBetweenPages: true,
        message
      }));
    }
  }

  handleChange = (event) => {
    const { target: input } = event;
    const value = input.value || '';
    this.setState<any>({ [input.name]: value.trim() });
  };

  handleSubmit = () => {
    const { dispatch } = this.props;
    const { email, password } = this.state;
    dispatch(login({ email, password }));
  };

  render() {
    const { email, password } = this.state;

    return (
      <Form
        className="access-form"
        onSubmit={this.handleSubmit}
        data={{ qa: 'access-form' }}
      >
        <FormField
          label={t('email_address')}
          validators={[
            isRequired(email),
            isEmail(email)
          ]}
        >
          <Input
            autoFocus
            value={email}
            name="email"
            onChange={this.handleChange}
            data-qa="access-form__email"
          />
        </FormField>

        <FormField
          label={t('password')}
          validators={[
            isRequired(password)
          ]}
        >
          <Input
            value={password}
            name="password"
            onChange={this.handleChange}
            type="password"
            data-qa="access-form__password"
            autoComplete="current-password"
          />
        </FormField>

        <div className="access-actions__secondary">
          <Link
            className="access-actions__link"
            to="/users/request-password-reset"
          >
            {t('access_forgot_password_page')}
          </Link>
        </div>

        <div className="access-actions access-actions--center">
          <ActionButton
            type="submit"
            data={{ qa: 'access-form__button' }}
          >
            {t('login')}
          </ActionButton>
        </div>
      </Form>
    );
  }
}

export default connect()(LoginForm);
